export default __webpack_public_path__ + "static/products-sizes-capacity-hero-5d678c8b088451e675962b62520af82c.jpg";